export const accountEndpoint = "api/account";
